export const API = {
  AUTH_DEV: {
    LOGIN: '/dev/login',
    REFRESH: '/dev/refresh/'
  },
  AUTH: {
    LOGIN: '/user/login',
    REFRESH: '/user/refresh',
    LOGOUT: '/user/logout',
    REGISTER: '/business/signup',
    VERIFY: '/user/verifyEmail/'
  },
  LOCATION: {
    FIND_BY_ID: '/location/findById/',
    ADD_LOCATION: '/location/add',
    UPDATE_LOCATION: '/location/update',
    DELETE: '/location/delete/',
    LOCATION_ELIGILIBILITY: '/location/checkLocationEligibility/'
  },
  customer_appointment: {
    ALL_LOCATIONS: '/location/findAll',
    AVALIABLE_SLOTS_BY_DATE: 'appointment/getAvaliableSlotsByDate',
    AVALIABLE_SLOTS_BY_DATE_FOR_ADMIN: 'appointment/getSlotsForAdmin',
    CREATE_APPOINMNET: '/appointment/public/create',
    CREATE_APPOINMNET_BOOKINGID: '/appointment/public/take-payment',
    APPOINMNET_SUMMARY: '/appointment/public/appointmentSummary/',
    CREATE_APPOINMENT_FROM_DAHBOARD: '/appointment/add',
    UPDATE_APPOINMENT_FROM_DAHBOARD: '/appointment/update',
    APPOINTMENT_WITHOUT_PAYMENT: '/appointment/public/create/no-payment',
    ALL_LOACTION_SUBDOMAIN: '/business/findBySubdomain/',
    CHECK_APPOINTMENT_AVALIABILITY: '/appointment/checkIfSlotBooked',
    PAGE_CONTENT: '/location/getBookingPageContent/',
    ADD_PAGE_CONTENT: '/location/updateLeftContentForBookingPage',
    ADD_PAGE_RIGHT_CPNTENT: '/location/updateRightContentForBookingPage',
    PROVISIONAL_BOOKING: '/appointment/getProvisionalBooking/',
    UPDATE_APPOINTMENT_WITHOUT_PAYMENT: '/appointment/public/updateAppointment'
  },
  WORKING_DAYS: {
    ALL_WORKING_DAYS: 'appointment/getAvaliableDates/',
    ALL_WORKING_DAYS_FOR_ADMIN: 'appointment/getAvailableDatesForAdmin/',
    WORKING_DAYS_BY_LOCATION: '/working-day/findAllByLocation/',
    UPDATE_WORKING_DAYS_BY_LOCATION: '/working-day/update',
    WORKING_DAYS_HISTORY_LOCATION: '/working-day-history/findAllByLocation/'
  },
  SERVICES: {
    ALL_SERVICES: 'service/findAllByLocation/',
    ADD_SERVICE: '/service/add',
    DELETE_SERVICE: '/service/delete/',
    UPDATE_SERVICE: '/service/update',
    UPDATE_STATUS: '/service/update',
    ALL_SERVICE_WITHOUT_FILTER: 'service/findByLocation/'
  },
  PATIENTS: {
    ADD_PATIENT: '/customer/add',
    GET_PATIENT: '/customer/findAll/',
    GET_PATIENT_BY_ID: '/customer/findById/',
    UPDATE_PATIENT: '/customer/update',
    DELETE_PATIENT: '/customer/delete/',
    TEMP_PATIENT: '',
    PAGINATION_PATIENTS: '/customer/findAllWithPagination',
    PAGINATION_SEARCH: '/customer/searchWithPagination',
    APPOINTMENTS_NOTES: '/notes/findAllByAppointment/',
    CUSTOMER_NOTES: '/notes/findAllByCustomer/',
    ADD_NOTES: '/notes/add',
    DELETE_NOTES: '/notes/delete/',
    UPDATE_NOTES: '/notes/update',
    CONVERSTAION_LOGS: '/communication-timeline/findAllByCustomerId/'
  },
  TIMEOFFS: {
    ADD: '/time-off/add',
    UPDATE: 'time-off/update',
    DELETE: 'time-off/delete/',
    GET_ALL_BY_LOCATION: '/time-off/findAll/'
  },
  OAUTH: {
    CREATE_SQUARE_PAYMENT_ACCOUNT: '/payment-accounts/add',
    GET_ALL_SQUARE_PAY_LOCATION: '/square/findAllSquareLocations/',
    BIND_SQUARE_LOCATION: '/payment-accounts/bind-square-location/',
    CHECK_SQUARE_CONNECTED: '/payment-accounts/isSquareConnected/',
    DISCONNECT_SQUARE: '/payment-accounts/deleteSquareAccount/',
    DISCONNECT_GOOGLE_CALENDAR: '/google-account/disconnect/',
    CHECK_GOOGLE_CALENDAR_CONNECTED: '/google-account/isConnected/'
  },
  BREAKS: {
    GET_ALL_BREAKS: '/break/findAll/',
    ADD_BREAK: '/break/add',
    REMOVE_BREAK: '/break/delete/',
    BREAKS_HISTORY: '/break/findAllHistory/'
  },
  APPOINTMENT: {
    GET_APPOINTMENT_BY_LOCATION: 'appointment/findAllByLocation/',
    CHANGE_APPOINTMENT_STATUS: '/appointment/change-status/',
    CANCEL_APPOINTMENT: '/appointment/cancel/',
    PAGINATION_APPOINTMENTS: '/appointment/getAllByLocationWithPagination',
    PAGINATION_APPOINTMENTS_SEARCH: '/appointment/searchWithPagination',
    GET_APPOINTMENT_BY_YEAR_MONTH: '/appointment/findAllByYearMonth/',
    DELETE: '/appointment/delete/',
    CHECK_TAB_VISIBILITY: '/appointment/checkDetails/',
    BY_ID: '/appointment/findById/',
    BULK_UPDATE_STATUS: '/appointment/bulkUpdateStatus',
    CONVERSTAION_LOGS: '/communication-timeline/findAllByAppointmentId/',
    TODAY_APPOINTMENT_DATA: '/dashboard/reportSmsAndEmail/',
    SMS_EMAIL_REPORT: '/dashboard/smsAndEmailReport/',
    BULK_REVIEW_EMAIL: '/appointment/bulkReviewEmail',
    MARK_APPOINTMENT_AS_PAID: '/appointment/markAsPaid'
  },
  GTM: {
    GET_GTM_ID: 'google-tag-manager/findByLocation/',
    ADD_GTM_ID: 'google-tag-manager/create',
    UPDATE_GTM_ID: 'google-tag-manager/edit',
    IS_CONNECTED: '/google-tag-manager/isGoogleTagManagerConnected/'
  },
  ADMIN: {
    ADD_ADMIN: '/user/register/admin',
    UPDATE_ADMIN: '/user/profile/update',
    GET_ALL_ADMIN: '/user/findAllAdminsAndBusinessAdminsByLocation/',
    DELETE_ADMIN: '/user/delete/',
    CHANGE_APPOINTMENT_STATUS: '/appointment/change-status/',
    CANCEL_APPOINTMENT: '/appointment/cancel/',
    FREEZE_ADMIN: '/user/updateStatus/',
    RESET_ADMIN: '/user/sendPasswordResetEmail/'
  },
  PAYEMNT_TRANSACTIONS: {
    GET_ALL_PAYMENTS: '/paymentTransaction/getAllByLocation/',
    PAGINATION_PAYEMNTS: '/paymentTransaction/getAllByLocationWithPagination',
    PAGINATION_LOGS: '/paymentLog/findAllByLocation',
    PAGINATION_PAYMENT_LOG_SEARCH: '/paymentLog/searchWithPagination',
    PAYMENT_HISTORY_SEARCH: '/paymentTransaction/searchWithPagination'
  },
  REFUND: {
    CLAIM_REFUND: '/refund/issue',
    REFUNDS_LIST: '/refund/findAllByPaymentTransaction/',
    PAGINATION_REFUNDS: '/refund/findAllByLocation',
    PAGINATION_REFUNDS_SEARCH: '/refund/searchWithPagination'
  },
  BOOKING_POLICIES: {
    GET_POLICIES: '/location/findById/',
    ADD_POLICIES: '/location/changeCancellationPolicy',
    ADD_WINDOW_SIZE: '/location/changeScheduleWidowSize',

    ADD_EMAIL_SCHEDULER: '/location/updateCustomerReminderTime',
    DOUBLE_BOOKINGS: '/location/updateDoubleBookingSettings',
    TIME_FORMAT: '/location/updateSlotsFormat',
    ADD_PAST_WINDOW_SIZE: '/location/changeBackDateScheduleSize/'
  },
  NOTIFICATIONS: {
    GET_ALL_NOTFICATIONS: '/notifications/findAllByLocation/',
    MARK_ALL_NOTIFICATIONS_READ: '/notifications/markAllRead'
  },
  CANCELLATION: {
    GET_BYLOCATION: '/location/findCancellationPolicy/',
    ADD_POLICY: '/location/updateTermsAndConditions',
    GET_POLICY: '/location/findById/'
  },
  PROFILE: {
    GET: '/user/profile/',
    UPDATE: '/user/updateProfile'
  },
  BUSINESS: {
    GET: '/business/findAllWithLocations',
    ADD: '/business/registerNew',
    BY_ID: '/business/findById/',
    DELETE: '/business/delete/',
    UPDATE: '/business/update'
  },
  PAYMENT_LOGS: {
    GET: '/paymentLog/findAllByAppointment/'
  },
  DASHBOARD: {
    LOCATION_ADMIN: '/dashboard/forLocation/',
    BUSINESS_ADMIN: '/dashboard/forBusiness/',
    ALL_TIME_REVENUE: '/dashboard/allTimeRevenueReport'
  },
  S3: {
    PRESIGNED_URL: '/s3/getUrl/'
  },
  FORGOT_PASSWORD: {
    SEND_PASSWORD: '/user/sendPasswordResetEmail/',
    RESET_PASSWORD: '/user/resetPassword'
  }
};
